//It must be regular export due to usage in web pack config.
module.exports = {
    get() {
        //TODO: Be careful with that, changing this value breaks dev server. Browser doesn't connect to WS.
        return "";
    },
    fixOldV3(url) {
        return url.replace(/^\/v3\/(.+)/, "/$1");
    },
};
